import React from 'react';
import { Lightbulb, Rocket, TrendingUp, BarChart } from 'lucide-react';
import { BusinessStage, QuestionnaireData } from '../../types';

interface BusinessStageStepProps {
  data: Partial<QuestionnaireData>;
  onChange: (data: Partial<QuestionnaireData>) => void;
}

const stages = [
  {
    id: 'idea' as BusinessStage,
    title: 'Idea Stage',
    description: 'Planning and validating',
    icon: Lightbulb,
  },
  {
    id: 'launching' as BusinessStage,
    title: 'Launching',
    description: 'Getting ready to launch',
    icon: Rocket,
  },
  {
    id: 'growing' as BusinessStage,
    title: 'Growing',
    description: 'Established and growing',
    icon: TrendingUp,
  },
  {
    id: 'scaling' as BusinessStage,
    title: 'Scaling',
    description: 'Rapidly expanding',
    icon: BarChart,
  },
];

export function BusinessStageStep({ data, onChange }: BusinessStageStepProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {stages.map((stage) => {
        const Icon = stage.icon;
        return (
          <button
            key={stage.id}
            onClick={() => onChange({ businessStage: stage.id })}
            className={`p-6 rounded-xl border-2 transition-all ${
              data.businessStage === stage.id
                ? 'border-blue-600 bg-blue-50'
                : 'border-gray-200 hover:border-blue-200 hover:bg-gray-50'
            }`}
          >
            <Icon className={`w-8 h-8 mb-4 ${
              data.businessStage === stage.id ? 'text-blue-600' : 'text-gray-600'
            }`} />
            <h3 className="text-lg font-semibold mb-2">{stage.title}</h3>
            <p className="text-gray-600">{stage.description}</p>
          </button>
        );
      })}
    </div>
  );
}

export default BusinessStageStep;